import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Chips, GradientMark, PageHeader, XpBadge } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { courses } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Course = () => {
  const { saved, markSaved } = useStudent();

  return (
    <>
      <PageHeader
        title="Courses"
        right={<button type="button" className="sa-ib" aria-label="Search"><Icon name="search" /></button>}
      />
      <div className="sa-hero">
        <div className="sa-b">Learn Today,<br />Lead Tomorrow</div>
        <p>Build skills, get certified,<br />create your future.</p>
        <Icon name="bulb" className="float" />
      </div>
      <Chips group="learn" options={['All', 'Recommended', 'Popular', 'My Courses']} />
      {courses.map((course) => {
        const enrolled = Boolean(saved[course.id]);
        return (
          <div className="sa-card sa-item" key={course.id}>
            <GradientMark name={course.icon} from={course.from} to={course.to} />
            <div className="sa-sp">
              <div className="sa-b" style={{ fontSize: 14 }}>{course.title}</div>
              <div className="sa-mut">
                {course.category} · <Icon name="star" filled className="tiny" /> {course.rating}
              </div>
              <span className="sa-tag">Certificate</span>
              <XpBadge amount={100} />
            </div>
            <button
              type="button"
              className={`sa-btn${enrolled ? ' ok' : ''}`}
              onClick={() => markSaved(course.id, 'Enrolled')}
            >
              {enrolled ? 'Enrolled' : 'Enroll'}
            </button>
          </div>
        );
      })}
    </>
  );
};

export default Course;
